<template>
    <div>
        <b-modal id="add-nextofkin" ref="modal" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <template #modal-title>
                <h6 class="m-0 fw-bold text-green text-sm">Beneficiary</h6>
            </template>
            <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="row">
                    <div class="col-md-6">
                        <b-form-group label-for="surname" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="surname">Surname <star></star></label>
                            </template>
                            <b-form-input id="surname" v-model="form.surname" v-validate="{ required: true }"
                                :state="validateState('surname')" name="surname" class="mt-1 field-container fields"
                                type="text" required></b-form-input>
                            <b-form-invalid-feedback>
                                The Surname field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.surname">
                                {{ form.errors.surname[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="other_names" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="other_names">Other Name(s) <star></star></label>
                            </template>
                            <b-form-input id="other_names" v-model="form.other_names" v-validate="{ required: true }"
                                :state="validateState('other_names')" name="other_names" class="mt-1 field-container fields"
                                type="text" required></b-form-input>
                            <b-form-invalid-feedback>
                                The Surname field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.other_names">
                                {{ form.errors.other_names[0] }}
                            </errors>
                        </b-form-group>
                    </div>

                    <div class="col-md-6">
                        <b-form-group label-for="email" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="email">Email </label>
                            </template>
                            <b-form-input id="email" v-model="form.email" name="email"
                                class="mt-1 field-container fields" type="email" required></b-form-input>
                            <b-form-invalid-feedback>
                                The Email field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.email">
                                {{ form.errors.email[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <label class="akkurate-dark small" for="dob">Date of Birth </label>
                        <b-form-group id="dob" label-for="dob">
                            <b-form-input class="mb-3 mt-2 field-container fields" type="date" v-model="form.dob"
                                required></b-form-input>
                            <errors v-if="form.errors.dob">
                                {{ form.errors.dob[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="phone" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="phone">Phone Number <star></star></label>
                            </template>
                            <b-form-input id="phone" v-model="form.phone" v-validate="{ required: true }"
                                :state="validateState('phone')" name="phone" class="mt-1 field-container fields"
                                type="number" required></b-form-input>
                            <b-form-invalid-feedback>
                                The Phone number field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.phone">
                                {{ form.errors.phone[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group label-for="relation" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="relation">Relation <star></star></label>
                            </template>
                            <b-form-input id="relation" v-model="form.relation" v-validate="{ required: true }"
                                :state="validateState('relation')" name="relation" class="mt-1 field-container fields"
                                type="text" required></b-form-input>
                            <b-form-invalid-feedback>
                                The Relations field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.relation">
                                {{ form.errors.relation[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label-for="address" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="address">Address </label>
                            </template>
                            <b-form-textarea class="mt-1 fields" id="address" name="address" v-model="form.address"
                                placeholder="Enter Address..."></b-form-textarea>
                            <b-form-invalid-feedback>
                                The Address field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.address">
                                {{ form.errors.address[0] }}
                            </errors>
                        </b-form-group>
                    </div>
                    <div class="col-12 col-md-6">
                        <b-form-group label-for="address" class="mb-2">
                            <template #label>
                                <label class="akkurate-dark small" for="percentage_share">Percentage Share </label>
                            </template>
                            <b-form-input id="percentage_share" v-model="form.percentage_share"
                                v-validate="{ required: true }" :state="validateState('percentage_share')"
                                name="percentage_share" class="mt-2 field-container fields" type="number"
                                max="100"
                                required></b-form-input>
                            <b-form-invalid-feedback>
                                The Percentage Share field is required
                            </b-form-invalid-feedback>
                            <errors v-if="form.errors.percentage_share">
                                {{ form.errors.percentage_share[0] }}
                            </errors>
                        </b-form-group>
                    </div>


                </div>
            </form>
            <template #modal-footer="{ ok }">
                <b-button @click="ok()" type="submit" class="btn akkurate-green-btn btn-size text-white me-2">
                    <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'plus']" /> Add</span></b-button>
                <b-button @click="$bvModal.hide('add-nextofkin')"
                    class="btn akkurate-gray-btn btn-size text-white">
                    <span class="akkurate-small"><font-awesome-icon :icon="['fas', 'close']" />
                        Close</span></b-button>
            </template>

        </b-modal>
    </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
    name: "AddAccount",
    components: {
        Multiselect,
    },
    watch: {
      'form.percentage_share': {
          deep: true,
            handler() {
                let percentage = this.form.percentage_share
                // console.log(typeof percentage)
                // console.log(Number(percentage))
              if (Number(percentage) > 100) {
                  this.form.percentage_share = '100';
             }
          }
      }
  },
    data() {
        return {
            form: {
                other_names: "",
                surname: "",
                email: "",
                dob: "",
                phone: "",
                relation: "",
                address: "",
                percentage_share: "",
                errors: [],
            },
            isSaving: false,
            add_or_edit: "add",
        }
    },
    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetModal() {
            this.form.other_names = '';
            this.form.surname = '';
            this.form.dob = '';
            this.form.email = '';
            this.form.phone = '';
            this.form.relation = '';
            this.form.percentage_share = '';
            this.form.address = '';;
        },
        handleOk(bvModalEvent) {
            // Prevent modal from closing
            bvModalEvent.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
        handleSubmit() {
            // Exit when the form isn't valid
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                this.$emit('addNextOfKin', this.form)
                this.$bvModal.hide('add-nextofkin')

            });
            // Hide the modal manually

        }
    }
}
</script>